import { useMemo } from 'react';

import { useFlag } from 'lane-shared/hooks';
import {
  getWebhookProperties,
  getAvailableWebhookEvents,
} from 'lane-shared/helpers/webhooks/WebhookType';
import { PropertiesInterface } from 'lane-shared/types/properties/Property';

import { FeatureFlag } from 'constants-flags';

/**
 * Returns the Webhook properties with the subscribable `events` filtered by the
 * channel's feature flags, so flag-gated events (e.g. reservation events) are
 * only offered when enabled. Also includes the editable signingKey property
 * when the flag is ON.
 */
export function useWebhookProperties(): PropertiesInterface {
  const isReservationWebhookEnabled =
    useFlag(FeatureFlag.ContentReservationEventWebhook, false) ?? false;

  return useMemo(() => {
    const baseProperties = getWebhookProperties(isReservationWebhookEnabled);
    const availableEvents = getAvailableWebhookEvents({
      isReservationWebhookEnabled,
    });

    const eventsProperty = baseProperties.events;

    return {
      ...baseProperties,
      events: {
        ...eventsProperty,
        validators: eventsProperty.validators?.map(validator =>
          validator.name === 'In'
            ? { ...validator, value: availableEvents }
            : validator
        ),
      },
    };
  }, [isReservationWebhookEnabled]);
}
